<div class="row gx-4 gy-3">
  @for (category of categories; track category) {
    <div class="col-md-6 col-xl-4">
      <label class="card-selectable mb-0" [ngClass]="{ 'border-danger': isInvalid }" [attr.data-test]="'option' + category">
        <div class="text-center mb-2">
          @if (category === 'StromGas') {
            <img [src]="'Strom' | categoryIconSrc" alt="" class="mb-2 mr-2" style="max-width: 50px" />
            <img [src]="'Gas' | categoryIconSrc" alt="" class="mb-2" style="max-width: 50px" />
            <br />
            <h4 class="mb-0 h6" data-test="product-category-text" [style.font-size]="'18px'">{{ category | translateCategory }}</h4>
          }
          @if (category !== 'StromGas') {
            <mwe-product-icon [category]="category" size="md" textNodeType="h4" />
          }
        </div>
        <div class="text-center">
          <input
            type="radio"
            id="option{{ category }}"
            name="product-categories"
            class="form-check-input"
            [value]="category"
            (change)="onSelected(category)"
            [ngClass]="{ 'is-invalid': isInvalid }"
          />
        </div>
      </label>
    </div>
  }
  @if (isInvalid && errorMessage) {
    <p class="font-size-11 text-danger mt-2 mb-0">
      <i class="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
      <span [translate]="errorMessage"></span>
    </p>
  }
</div>
